<template>
    <div class="field" :class="`${short ? 'field-short' : ''} ${fieldClass} ${inline ? 'field-inline-flex' : ''}`">
        <slot name="label">
            <label :for="resolvedId" v-if="label" v-text="label"></label>
        </slot>

        <slot></slot>
        
        <slot name="error">
            <div v-if="hasError" class="break"></div>
            <p class="text-error" v-if="hasError">
                <sup>*</sup> <span v-text="error"></span>
            </p>
        </slot>
    </div>
</template>

<script>
export default {
    props: {
        form: Object,
        name: String,
        label: String,
        short: Boolean,
        inline: Boolean,
        id: {
            type: String,
            default: null
        },
        errorClasses: {
            type: String,
            default: "field-error"
        }
    },
    computed: {
        error() {
            return this.form.errors.get(this.name);
        },
        hasError() {
            return this.form.errors.has(this.name);
        },
        fieldClass() {
            return this.hasError ? this.errorClasses : "";
        },
        resolvedId() {
            return this.id === null ? this.name : this.id;
        }
    }
};
</script>